<template>
  <BaseDialog centered contentClass="edit-tenant description-mode" ref="dialog" persistent :show-actions="true">
    <template slot="title">
      {{ $t('page.admin-tenants.edit-tenant-description') }}
    </template>
    <template slot="content">
      <form :name="formName" @click.prevent>
        <div>
          <div v-show="language === 'fr'">
            <FormLabel>{{ $t('page.admin-tenant.edit-label-fr') }}</FormLabel>
            <FormInput
              is-textarea
              is-compact
              name="tenant-description-fr"
              autofocus
              :rows="5"
              :value="descriptionFr"
              :placeholder="$t('page.admin-tenant.services-description.empty-description')"
              @input="descriptionFr = $event"
            />
          </div>

          <div v-show="language === 'en'">
            <FormLabel>{{ $t('page.admin-tenant.edit-label-en') }}</FormLabel>
            <FormInput
              is-textarea
              is-compact
              name="tenant-description-en"
              autofocus
              :rows="5"
              :value="descriptionEn"
              :placeholder="$t('page.admin-tenant.services-description.empty-description')"
              @input="descriptionEn = $event"
            />
          </div>
        </div>

        <div class="base-dialog__edit-tenant--actions">
          <FormButton is-outlined @click.native="cancelClick">
            {{ $t('actions.cancel') }}
          </FormButton>

          <FormButton @click.native="onSubmit">
            <span>{{ $t('dialog.filters.advanced.apply') }}</span>
          </FormButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import FormLabel from '@/components/form/FormLabel.vue';
import FormInput from '@/components/form/FormInput';
import BaseDialog from '@/components/base/BaseDialog.vue';
import FormButton from '@/components/form/FormButton.vue';

export default {
  name: 'EditTenantDescription',
  components: {
    BaseDialog,
    FormButton,
    FormLabel,
    FormInput,
  },
  data() {
    return {
      descriptionFr: '',
      descriptionEn: '',
      language: 'fr',
    };
  },
  props: {
    formName: {
      type: String,
      default: 'editTenantForm',
    },
  },
  methods: {
    openDialog(tenant, language) {
      this.language = language;
      this.descriptionFr = tenant.description.fr;
      this.descriptionEn = tenant.description.en;

      this.$refs.dialog.openModal();
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
    cancelClick() {
      this.closeDialog();
    },
    onSubmit() {
      if (this.language === 'fr') {
        this.$emit('update-description', 'fr', this.descriptionFr);
      } else {
        this.$emit('update-description', 'en', this.descriptionEn);
      }
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss">
.base-dialog__edit-tenant {
  height: auto;
  width: 550px;
  position: relative;

  &.description-mode {
    width: 800px;
  }
  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    background: $color-white !important;
  }

  &--actions {
    margin-top: 32px;
    justify-content: flex-end;
    display: flex;
    gap: 12px;
  }

  .form-input {
    padding: 4px 0 24px 0;
  }
}
</style>
